// extracted by mini-css-extract-plugin
export default {"EventsHome":"EventsHomeDark_EventsHome__yfO+I","Container":"EventsHomeDark_Container__Kvx9H","cardList":"EventsHomeDark_cardList__tMIbD","eventBtn":"EventsHomeDark_eventBtn__QLBUW"};